import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Banner from 'components/Banner';
import AtheleteDesc from 'components/AtheleteDetails';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import style from './Athelete.scss';// to import local scss fle


class Athelete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }
  render() {
    const bannerData = {
      bannerHeader: 'GET DISCOVERED NATIONALLY',
      bannerDesc: "We're proud to be the largest athletic recruiting platform since we were  founded. The sports recruiting world has shifted, and we're always evolving.",
      backgroundUrl: 'https://media.dev.myrecruitboard.com/Images/bgDesktop.png',
      fullsize: false,
      otherPages: true,
    };
    return (
      <div className={cn('row', style.atheleteContainer)}>
        <div className={cn('col s12 m6', style.bannerAthelete)}>
          <Banner data={bannerData} />
        </div>
        <div className={cn('col s12 m6', style.bannerAthelete)}>
          <AtheleteDesc viewer="athlete" />
        </div>
      </div>
    );
  }
}

Athelete.propTypes = {
  data: PropTypes.isRequired,
};

export default Athelete;



// WEBPACK FOOTER //
// ./src/containers/Athelete/Athelete.js